import { useEffect, useRef } from "react";

// Acha o container que rola de fato (no app é o BodyContainer, não a janela)
const getScrollParent = (node: HTMLElement | null): HTMLElement | null => {
  let current = node?.parentElement ?? null;
  while (current) {
    const { overflowY } = window.getComputedStyle(current);
    if (overflowY === "auto" || overflowY === "scroll") return current;
    current = current.parentElement;
  }
  return null;
};

// Chama `onLoadMore` quando o elemento sentinela (colocado no fim da lista)
// chega perto da área visível. Enquanto `enabled` for false (carregando, sem
// mais páginas ou com erro) nada acontece; quando volta a true o observer é
// recriado e dispara de novo se o sentinela ainda estiver visível.
export function useInfiniteScroll(onLoadMore: () => void, enabled: boolean) {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const callbackRef = useRef(onLoadMore);
  callbackRef.current = onLoadMore;

  useEffect(() => {
    const node = sentinelRef.current;
    if (!enabled || !node || typeof IntersectionObserver === "undefined") {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) callbackRef.current();
      },
      // começa a carregar um pouco antes de chegar no fim
      { root: getScrollParent(node), rootMargin: "0px 0px 300px 0px" },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [enabled]);

  return sentinelRef;
}
